import React from "react";
import type { ReactNode } from "react";
import { AssistantRuntimeProvider, useLocalRuntime } from "@assistant-ui/react";
import { TooltipProvider } from "@radix-ui/react-tooltip";

import { RequirePerm } from "components/guards";
import { FEATURE } from "store/types";

import { anthropicAdapter } from "./anthropic-adapter";
import { AssistantModal } from "./assistant-modal";

interface OpsHelmAssistantProviderProps {
  children: ReactNode;
}

/**
 * OpsHelm Assistant Provider
 *
 * This component provides the assistant-ui runtime context and renders
 * the floating modal chat button. Wrap your app with this provider to
 * enable the AI assistant throughout the application.
 *
 * Uses Anthropic's Claude API with MCP connector support.
 * Configure your API key and MCP server in anthropic-adapter.ts.
 */
export const OpsHelmAssistantProvider = ({ children }: OpsHelmAssistantProviderProps) => {
  // Initialize the local runtime with the Anthropic adapter
  // Configure API key and MCP server in anthropic-adapter.ts
  const runtime = useLocalRuntime(anthropicAdapter);

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      <TooltipProvider>
        {children}
        <RequirePerm access={{ feature: FEATURE.AI_ASSISTANT }} element={<AssistantModal />} />
      </TooltipProvider>
    </AssistantRuntimeProvider>
  );
};

export default OpsHelmAssistantProvider;
